export const apiConstants = {
  category: '/categories',
};
